import { observer } from "mobx-react";
import React from "react";

import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";

import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { EventMarkets } from "./EventMarkets";

export const EventMarketsContent = observer(function EventMarketsContent() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store.currentTab === EventBodyTabs.Markets) {
		return <EventMarkets store={store} />;
	}
	return null;
});
